import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { locToRange, offsetToPosition } from 'graphql-language-service-utils';
export var LANGUAGE = 'GraphQL';

function assert(value, message) {
  if (!value) {
    throw new Error(message);
  }
}

function getRange(text, node) {
  var location = node.loc;
  assert(location, 'Expected ASTNode to have a location.');
  return locToRange(text, location);
}

function getPosition(text, node) {
  var location = node.loc;
  assert(location, 'Expected ASTNode to have a location.');
  return offsetToPosition(text, location.start);
}

export function getDefinitionQueryResultForNamedType(text, node, dependencies) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var name, defNodes, definitions;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = node.name.value;
            defNodes = dependencies.filter(function (_ref) {
              var definition = _ref.definition;
              return definition.name && definition.name.value === name;
            });

            if (!(defNodes.length === 0)) {
              _context.next = 4;
              break;
            }

            throw Error("Definition not found for GraphQL type ".concat(name));

          case 4:
            definitions = defNodes.map(function (_ref2) {
              var filePath = _ref2.filePath,
                  content = _ref2.content,
                  definition = _ref2.definition;
              return getDefinitionForNodeDefinition(filePath || '', content, definition);
            });
            return _context.abrupt("return", {
              definitions: definitions,
              queryRange: definitions.map(function (_) {
                return getRange(text, node);
              })
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export function getDefinitionQueryResultForFragmentSpread(text, fragment, dependencies) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var name, defNodes, definitions;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            name = fragment.name.value;
            defNodes = dependencies.filter(function (_ref3) {
              var definition = _ref3.definition;
              return definition.name.value === name;
            });

            if (!(defNodes.length === 0)) {
              _context2.next = 4;
              break;
            }

            throw Error("Definition not found for GraphQL fragment ".concat(name));

          case 4:
            definitions = defNodes.map(function (_ref4) {
              var filePath = _ref4.filePath,
                  content = _ref4.content,
                  definition = _ref4.definition;
              return getDefinitionForFragmentDefinition(filePath || '', content, definition);
            });
            return _context2.abrupt("return", {
              definitions: definitions,
              queryRange: definitions.map(function (_) {
                return getRange(text, fragment);
              })
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}
export function getDefinitionQueryResultForDefinitionNode(path, text, definition) {
  return {
    definitions: [getDefinitionForFragmentDefinition(path, text, definition)],
    queryRange: definition.name ? [getRange(text, definition.name)] : []
  };
}

function getDefinitionForFragmentDefinition(path, text, definition) {
  var name = definition.name;

  if (!name) {
    throw Error('Expected ASTNode to have a Name.');
  }

  return {
    path: path,
    position: getPosition(text, definition),
    range: getRange(text, definition),
    name: name.value || '',
    language: LANGUAGE,
    projectRoot: path
  };
}

function getDefinitionForNodeDefinition(path, text, definition) {
  var name = definition.name;
  assert(name, 'Expected ASTNode to have a Name.');
  return {
    path: path,
    position: getPosition(text, definition),
    range: getRange(text, definition),
    name: name.value || '',
    language: LANGUAGE,
    projectRoot: path
  };
}